import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Login from './components/auth/Login';
import Dashboard from './components/layout/Dashboard';

import ProyectoState from './context/proyectos/proyectoState';
import BarraPrincipalState from './context/barraprincipal/barraprincipalState';
import TareaState from './context/tareas/tareaState';
import AlertaState from './context/alerta/alertaState';
import AuthState from './context/autenticacion/authState';
import tokenAuth from './config/tokenAuth';
import RutaPrivada from './components/rutas/RutaPrivada';

// Revisar si tenemos un token
const token = localStorage.getItem('token');
if(token) {
  tokenAuth(token);
}

function App() {
  return (
    <ProyectoState>
      <BarraPrincipalState>
        <TareaState>
          <AlertaState>
            <AuthState>
              <Router>
                <Switch>
                  <Route exact path="/" component={Login} />
                  <RutaPrivada exact path="/dashboard" component={Dashboard} />
                </Switch>
              </Router>
            </AuthState>
          </AlertaState>  
        </TareaState>
      </BarraPrincipalState>
    </ProyectoState>
  );
}

export default App;
